import { getDefaultMandatorSlug } from "./getDefaultMandatorSlug";

export const getAppUrlSufix = () =>
  getDefaultMandatorSlug() === "boersennews_de" ? "/" : "";

export const getAccountUrl = (
  id: number,
  type: "depot" | "account" = "account"
) =>
  `${import.meta.env.VITE_APP_APP_URL}/${
    type === "account" ? "accounts" : "depots"
  }/${id}`;

export const goToAccount = (id: number) =>
  (window.location.href = getAccountUrl(id));
export const goToDepot = (id: number) =>
  (window.location.href = getAccountUrl(id, "depot"));

export const getDashboardUrl = () =>
  `${import.meta.env.VITE_APP_APP_URL}${getAppUrlSufix()}`;
export const goToDashboard = () => (window.location.href = getDashboardUrl());

export const getInvestmentsUrl = () =>
  `${import.meta.env.VITE_APP_APP_URL}/investments`;
export const goToInvestments = () =>
  (window.location.href = getInvestmentsUrl());
